import * as ErrorsActionTypes from '../../types/errors';

export default function errors(state = {}, action = {}) {
    switch (action.type) {
        case ErrorsActionTypes.SET_REMOVED_COLLABORATOR_ERROR: {
            return { ...state, removedCollaborator: action.payload };
        }

        default: {
            return state;
        }
    }
}
